import _get from 'lodash/get';
import VttItem from './vtt-item';

/**
 *
 * @class MediaItem
 * @desc Represents a media item to playback
 * @module MediaItem
 *
 */
class MediaItem {

    constructor(config) {

        /**
         *
         * @type {string}
         * @desc address of the media resource
         *
         */
        this.src = _get(config, 'src');

        /**
         *
         * @type {string}
         * @desc The MIME-type of the resource, optionally with a codecs parameter. Examples:
         * mp4: "video/mp4"
         * m3u8: "application/x-mpegURL"
         *
         */
        this.type = _get(config, 'type');

        /**
         *
         * @type {array} List of VttItems
         * @desc VttItems to apply to the video tag for subtitles
         *
         */
        this.vttItems = this.getVttItems(_get(config, 'vttItems', []));

        /**
         *
         * @type {string}
         * @desc The url pointer to the poster image to use
         *
         */
        this.poster = _get(config, 'poster');
        
        /**
         *
         * @type {object}
         * @desc Media item metadata
         *
         */
        this.metaData = _get(config, 'metaData');

    }

    /**
     *
     * @desc builds a list of VttItems
     * @param {Array} vttList list of VTT config objects
     *
     */
    getVttItems(vttList) {

        const vttItems = [];

        vttList.forEach((item) => {

            vttItems.push(new VttItem(item));

        });

        return vttItems;

    }

}

export default MediaItem;
